





const PREROLL_TYPES = ["traditional", "cigarette", "blunt", "infused"];

export default PREROLL_TYPES;